export const getSessionId = (): string => {
  if (typeof window === "undefined") {
    return ""; // Server-side, fallback
  }
  
  const match = document.cookie.match(new RegExp('(^| )x-session-id=([^;]+)'));
  let sessionId = match ? match[2] : null;

  if (!sessionId) {
    sessionId = `sess_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    document.cookie = `x-session-id=${sessionId}; path=/; max-age=86400;`; // 1 day
  }
  return sessionId;
};

export const getLeadId = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }
  return localStorage.getItem("leadId");
};

export const setLeadId = (leadId: string): void => {
  if (typeof window === "undefined") return;
  localStorage.setItem("leadId", leadId);
};
